export default __webpack_public_path__ + "static/media/watson-6.46bb2bb8.png";